import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { fmtSEK } from "../revenue/format";

export default function IndirectSummary({ summary }) {
  const warnings = summary.warnings?.length || 0;
  const kpis = [
    { label: "Expected FY Regular Indirect", value: summary.expected_fy_regular, strong: true, testId: "ic-summary-expected-fy", format: "sek" },
    { label: "YTD Actual", value: summary.has_closed_months ? summary.ytd_actual : null, testId: "ic-summary-ytd", format: "sek" },
    { label: "Forecast Remaining", value: summary.has_closed_months ? summary.forecast_remaining : null, testId: "ic-summary-remaining", format: "sek" },
    { label: "Group Overhead (6591)", value: summary.expected_fy_group_overhead, testId: "ic-summary-group-overhead", format: "sek", naLabel: "Not calculated" },
    { label: "Active Cost Accounts", value: summary.active_accounts, testId: "ic-summary-accounts", format: "int" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 mb-4" data-testid="ic-summary">
      {kpis.map((kpi) => (
        <div
          key={kpi.label}
          className={`rounded-lg border p-3 ${kpi.strong ? "bg-[#0052CC] border-[#0052CC]" : "bg-white border-slate-200"}`}
          data-testid={kpi.testId}
        >
          <div className={`text-[11px] font-semibold uppercase tracking-wider ${kpi.strong ? "text-blue-100" : "text-slate-500"}`}>
            {kpi.label}
          </div>
          <div className={`text-lg font-bold mt-0.5 ${kpi.strong ? "text-white" : "text-slate-900"}`}>
            {kpi.value == null
              ? kpi.naLabel || "N/A"
              : kpi.format === "sek" ? `${fmtSEK(kpi.value)} kr` : kpi.value}
          </div>
        </div>
      ))}
      <div className={`rounded-lg border p-3 ${warnings ? "bg-[#FFFBEB] border-[#FDE68A]" : "bg-white border-slate-200"}`} data-testid="ic-summary-completeness">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Data Completeness</div>
        <div className="text-lg font-bold mt-0.5 flex items-center gap-1.5 text-slate-900">
          {warnings ? (
            <>
              <AlertTriangle className="h-4 w-4 text-[#B45309]" />
              {warnings} warning{warnings === 1 ? "" : "s"}
            </>
          ) : (
            <>
              <CheckCircle2 className="h-4 w-4 text-[#047857]" />
              Complete
            </>
          )}
        </div>
      </div>
    </div>
  );
}
